module.exports = __webpack_public_path__ + "img/1Pro3-3@2x.293990be.png";